import { useState } from "react";
import { useTranslation } from "react-multi-lang";
import OrderInfo from "./OrderInfo";
import OrderProduct from "./OrderProduct";
import GeneralUtility from "../../../../utils/general-utility";
import Action from "../../redux/Action";

const OrderItem = ({
  item,
  showInvoice,
  showTracking,
  setPickUp,
  getResi,
  setComplete,
  setCancel,
  loadingButton,
}) => {
  const t = useTranslation();
  const [showMore, setShowMore] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const BASE_IMAGE = process.env.REACT_APP_ASSETS_IMAGE;
  let statusName;
  let statusColor;
  let statusTextColor;

  const enumStatus = Object.freeze({
    SELF_PICKUP: t("orders.self_pickup"),
  });

  switch (item.status) {
    case "PAID":
      statusName = t("orders.new_order");
      statusColor = "bg-gray-300";
      statusTextColor = "text-white";
      break;
    case "READY_TO_SELF_PICKUP":
      statusName = t("orders.self_pickup");
      statusColor = "bg-[#7a87ed]";
      statusTextColor = "text-white";
      break;
    case "ON_DELIVERY":
      statusName = t("orders.on_shipment");
      statusColor = "bg-[#FFB8EC]";
      statusTextColor = "text-[#B52BB5]";
      break;
    case "COMPLETED":
      statusName = t("general.completed");
      statusColor = "bg-[#D0FFCC]";
      statusTextColor = "text-[#6AC167]";
      break;
    case "CANCELED":
      statusName = t("general.cancelled");
      statusColor = "bg-[#FF9191]";
      statusTextColor = "text-white";
      break;
    case "RECEIVED":
      statusName = t("orders.received");
      statusColor = "bg-[#FCB769]";
      statusTextColor = "text-white";
      break;
    case "COMPLAINED":
      statusName = t("orders.complained");
      statusColor = "bg-[#FCB769]";
      statusTextColor = "text-white";
      break;
    default:
      statusName = "";
      statusColor = "";
      statusTextColor = "";
      break;
  }

  return (
    <div className="my-3 p-3 section-white">
      <div className="flex w-full justify-between items-center">
        <div className="sm:text-sm">
          {/* notifikasi count orders


          {(item.courier === "SELF_PICKUP" &&
            item.status === "READY_TO_SELF_PICKUP") ||
          item.status === "RECEIVED" ||
          item.status === "COMPLETED" ? (
            <span
              className={`p-1 ${(statusColor =
                "bg-[#7a87ed]")} ${(statusTextColor =
                "text-white")} rounded-lg`}
            >
              {(statusName = t("orders.self_pickup"))}
            </span>
          ) : (
            <span
              className={`p-1 ${statusColor} ${statusTextColor} rounded-lg`}
            >
              {statusName}
            </span>
          )}{" "}
          */}
          <span className={`p-1 ${statusColor} ${statusTextColor} rounded-lg`}>
            {statusName}
          </span>{" "}
          /{" "}
          <button
            className="text-gold-secondary font-semibold"
            onClick={showInvoice}
          >
            {item.invoice}
          </button>{" "}
          /{" "}
          <span>
            {item.customerName} / {item.dateCreated}
          </span>
        </div>
        <div className="flex gap-2">
          <button
            onClick={async () => {
              const customerId = item.customerId;
              const newIdChat = await Action.createNewChat(customerId);
              window.location.href = `/chat?room=${newIdChat}`;
            }}
            className={` cursor-pointer button hover:bg-green-primary hover:text-white text-xs tracking-widest font-bold text-green-secondary border-2 border-green-secondary bg-white border-opacity-40 rounded-xl p-1 px-3 flex justify-center`}
          >
            CHAT CUSTOMER
          </button>

          {(item.status === "PAID" && item.courier !== "SELF_PICKUP") ||
            item.status === "ON_DELIVERY" ? (
            <button
              disabled={loadingButton ?? false}
              className={`
                ${loadingButton ? "cursor-not-allowed" : "cursor-pointer"}
                button hover:bg-gray-primary hover:text-green-secondary text-xs tracking-widest font-bold text-gray-primary border-2 border-green-secondary bg-green-secondary border-opacity-40 rounded-xl p-1 px-3 flex justify-center`}
              onClick={() => {
                if (item.status === "PAID" && item.courier !== "SELF_PICKUP") {
                  // set pickup
                  setPickUp();
                  if (!loadingButton) {
                  }
                } else if (item.status === "ON_DELIVERY") {
                  // show modal tracking
                  showTracking();
                }
              }}
            >
              {item.status === "PAID" && item.courier !== "SELF_PICKUP" ? (
                loadingButton ? (
                  <svg
                    aria-hidden="true"
                    role="status"
                    className="inline w-4 h-4 text-gray-200 animate-spin dark:text-gray-600 m-auto"
                    viewBox="0 0 100 101"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                      fill="currentColor"
                    />
                    <path
                      d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                      fill="rgb(187,171,127)"
                    />
                  </svg>
                ) : (
                  t("orders.set_pick_up").toUpperCase()
                )
              ) : (
                t("orders.tracking").toUpperCase()
              )}
            </button>
          ) : null}

          {item.status === "ON_DELIVERY" && (
            <button
              className="button hover:bg-gray-primary hover:text-green-secondary text-xs tracking-widest font-bold text-gray-primary border-2 border-green-secondary bg-green-secondary border-opacity-40 rounded-xl p-1 px-3"
              onClick={() => {
                getResi();
              }}
            >
              {t("general.print_label").toUpperCase()}
            </button>
          )}

          {item.courier === "SELF_PICKUP" && (
            <>
              <div className="flex gap-1">
                {item.status === "READY_TO_SELF_PICKUP" && (
                  <button
                    className="button hover:bg-green-secondary hover:text-white text-xs tracking-widest font-bold text-green-secondary border-2 border-green-secondary bg-white border-opacity-40 rounded-xl p-1 px-3 ml-2"
                    onClick={() => {
                      setCancel();
                    }}
                  >
                    {t("orders.set_cancel").toUpperCase()}
                  </button>
                )}{" "}
                {(item.status === "PAID" ||
                  item.status === "READY_TO_SELF_PICKUP") && (
                    <button
                      disabled={loadingButton ?? false}
                      className={`
                ${loadingButton ? "cursor-not-allowed" : "cursor-pointer"}
                button hover:bg-gray-primary hover:text-green-secondary text-xs tracking-widest font-bold text-gray-primary border-2 border-green-secondary bg-green-secondary border-opacity-40 rounded-xl p-1 px-3 flex justify-center`}
                      onClick={() => {
                        if (item.status === "PAID") {
                          setPickUp();
                          if (!loadingButton) {
                          }
                        } else if (item.status === "READY_TO_SELF_PICKUP") {
                          setComplete();
                        }
                      }}
                    >
                      {item.status === "PAID" ? (
                        loadingButton ? (
                          <svg
                            aria-hidden="true"
                            role="status"
                            className="inline w-4 h-4 text-gray-200 animate-spin dark:text-gray-600 m-auto"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="currentColor"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="rgb(187,171,127)"
                            />
                          </svg>
                        ) : (
                          t("orders.set_pick_up").toUpperCase()
                        )
                      ) : (
                        t("orders.set_complete").toUpperCase()
                      )}
                    </button>
                  )}
              </div>
            </>
          )}
        </div>
      </div>
      <div className="w-full my-2" />
      <div className="flex">
        <div className="flex-1 mr-2">
          {!showMore ? (
            <OrderProduct product={item.product[0]} />
          ) : (
            <>
              {item.product.map((product, index) => (
                <li key={index}>
                  <OrderProduct product={product} />
                </li>
              ))}
            </>
          )}
          {item.product.length > 1 ? (
            <button
              className="w-full text-center border-t p-1"
              onClick={() => {
                setShowMore(!showMore);
              }}
            >
              {!showMore
                ? t("orders.see_more", { params: item.product.length - 1 })
                : t("orders.see_less")}
            </button>
          ) : (
            ""
          )}
        </div>
        <div className="flex-1">
          {item.courier === "SELF_PICKUP" ? (
            <div className="mb-1">
              <p className="text-gray-secondary">{t("orders.pickup_by")}</p>
              <p>{item.pickupBy}</p>
            </div>
          ) : (
            ""
          )}

          {item.courier === "SELF_PICKUP" && item.status === "PAID" ? (
            <div class="items-center text-sm">
              <p className="text-gray-secondary">
                {t("orders.pickup_date")}
                <br />
              </p>
              <div className="flex gap-1 items-center">
                <img
                  src={BASE_IMAGE + "dangers.png"}
                  className="w-3 h-3"
                  alt="dangers"
                />
                Let's click "Set Pickup" to display the pick-up date
              </div>
            </div>
          ) : item.status === "READY_TO_SELF_PICKUP" ? (
            <div class="items-center text-sm">
              <p className="text-gray-secondary">
                {t("orders.pickup_date")}
                <br />
              </p>
              <p>
                {item.startSelfPickupDate} - {item.endSelfPickupDate}
              </p>
            </div>
          ) : (
            ""
          )}

          {item.courier !== "SELF_PICKUP" && (
            <div className="mb-1">
              <p className="text-gray-secondary">{t("management.address")}</p>
              <p>{item.address}</p>
            </div>
          )}
        </div>
        <div className="flex flex-col flex-1 ml-2">
          <div className="flex flex-1 justify-between">
            <div className="flex-1">
              <p className="text-gray-secondary">{t("orders.courier")}</p>
              <p className="text-black">
                {item.courier === "SELF_PICKUP"
                  ? enumStatus[item.courier]
                  : item.courier}
              </p>
              {item.courier === "SELF_PICKUP" &&
                (item.status === "PAID" ||
                  item.status === "READY_TO_SELF_PICKUP") ? (
                <p className="text-gray-secondary">
                  {t("orders.selfpickup_courier")}
                </p>
              ) : (
                ""
              )}
            </div>
            <div className="flex-1">
              {item.courier !== "SELF_PICKUP" ? (
                <>
                  <p className="text-gray-secondary">
                    {t("orders.received_by")}
                  </p>
                  <p>{item.receivedBy}</p>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div className="flex flex-1 justify-between">
            <div className="flex-1">
              {item.receiptNumber !== "" ? (
                <>
                  <p className="text-gray-secondary">
                    {t("orders.receipt_number")}
                  </p>
                  <p>{item.receiptNumber}</p>
                </>
              ) : (
                <></>
              )}
            </div>
            <div className="flex-1 mb-1">
              {item.receivedDate !== "" ? (
                <>
                  <p className="text-gray-secondary">
                    {t("orders.received_date")}
                  </p>
                  <p>{item.receivedDate}</p>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="w-full my-2" />
      {/* INI COMPLAINT DI HIDE  */}
      {/* {item.complaint !== "" && item.status === "COMPLAINED" ? (
        <div className="max-w-[50%] border-2 border-[#BBAB7F] bg-[#F5F0E178] rounded-xl my-2 p-2">
          <p className="mb-1">{t("orders.complaint")}</p>
          <p className="font-bold">{item.complaint}</p>
        </div>
      ) : ""}
      */}
      <div className="flex w-full justify-between items-center px-3">
        <div className="relative flex items-center">
          <p>{t("dashboard.total_sales")}</p>
          <img
            onMouseEnter={() => {
              setShowInfo(true);
            }}
            onMouseLeave={() => {
              setShowInfo(false);
            }}
            className="h-3 ml-1"
            src={process.env.REACT_APP_ASSETS_IMAGE + "info-icon.svg"}
            alt="info-icon"
          />
          {showInfo ? (
            <OrderInfo
              productList={item.product}
              shipping={item.shipping + item.insuranceFee}
            />
          ) : (
            <></>
          )}
        </div>
        <p className="text-md text-green-primary font-bold">
          Rp {GeneralUtility.addCommas(item.total)}
        </p>
      </div>
    </div>
  );
};

export default OrderItem;
